import React from 'react';
import { Checkbox, STYLE_TYPE } from 'baseui/checkbox';
import { IDummyProps } from './types';
import { overrides as customOverrides } from './overrides';
import { mergeOverrides } from 'baseui';
import * as meta from '../../meta-data.json';

export const View = React.forwardRef(({ overrides, ...props }: IDummyProps, ref: any) => {
	return (
		<Checkbox
			data-epo={`epo-toggle-${meta.version}`}
			{...props}
			ref={ref}
			checkmarkType={STYLE_TYPE.toggle_round}
			overrides={
				overrides
					? mergeOverrides(customOverrides(props) as any, overrides as any)
					: (customOverrides(props) as any)
			}
		>
			{props.children}
		</Checkbox>
	);
});
